/* FreshChop — vanilla JS. Una funcion init por componente. */
(function () {
  "use strict";

  if (window.__mtBooted) return;
  window.__mtBooted = true;

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll(".mt-reveal");
    if (!els.length) return;

    function showAll() {
      els.forEach(function (el) { el.classList.add("mt-visible"); });
    }
    if (reduceMotion || !("IntersectionObserver" in window)) {
      showAll();
      return;
    }

    var vh = window.innerHeight || document.documentElement.clientHeight;

    els.forEach(function (el) {
      var group = el.closest("[data-mt-stagger]");
      if (group) {
        var siblings = group.querySelectorAll(".mt-reveal");
        var idx = Array.prototype.indexOf.call(siblings, el);
        el.style.setProperty("--mt-delay", (idx % 8) * 0.07 + "s");
      }
      // anything already on-screen at load: reveal immediately, no wait
      var top = el.getBoundingClientRect().top;
      if (top < vh * 0.92) el.classList.add("mt-visible");
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("mt-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -6% 0px", threshold: 0.1 }
    );
    els.forEach(function (el) {
      if (!el.classList.contains("mt-visible")) io.observe(el);
    });

    // failsafe: never leave content hidden
    setTimeout(showAll, 2500);
  }

  /* ---------- Marquee: duplicate content for a seamless loop ---------- */
  function initMarquee() {
    var tracks = document.querySelectorAll(".mt-marquee__track");
    tracks.forEach(function (track) {
      if (track.dataset.mtCloned === "1") return;
      var item = track.querySelector(".mt-marquee__item");
      if (!item) return;
      var clone = item.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      track.appendChild(clone);
      track.dataset.mtCloned = "1";
    });
  }

  /* ---------- FAQ: keep native <details>, just smooth the icon ---------- */
  function initFaq() {
    var items = document.querySelectorAll(".mt-faq__item");
    if (!items.length) return;
    items.forEach(function (item) {
      var summary = item.querySelector(".mt-faq__q");
      if (!summary) return;
      summary.addEventListener("click", function () {
        // allow only one open at a time within the same list
        var list = item.closest(".mt-faq__list");
        if (!list || item.open) return;
        list.querySelectorAll(".mt-faq__item[open]").forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  /* ---------- Count-up numbers ---------- */
  function initCountUp() {
    var nums = document.querySelectorAll("[data-mt-count]");
    if (!nums.length) return;
    if (reduceMotion || !("IntersectionObserver" in window)) {
      nums.forEach(function (n) { n.textContent = n.dataset.mtCount; });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        var target = parseFloat(el.dataset.mtCount);
        var suffix = el.dataset.mtSuffix || "";
        var dur = 1400;
        var start = performance.now();
        function tick(now) {
          var p = Math.min((now - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = target * eased;
          el.textContent = (target % 1 === 0 ? Math.round(val) : val.toFixed(1)) + suffix;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.4 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    var gallery = document.querySelector("[data-mt-gallery]");
    if (!gallery) return;
    var mainImg = gallery.querySelector("[data-mt-gallery-main]");
    var thumbs = gallery.querySelectorAll("[data-mt-gallery-thumb]");
    if (!mainImg || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var full = thumb.getAttribute("data-full");
        var alt = thumb.getAttribute("data-alt") || "";
        if (full) {
          mainImg.src = full;
          mainImg.alt = alt;
        }
        thumbs.forEach(function (t) { t.setAttribute("aria-current", "false"); });
        thumb.setAttribute("aria-current", "true");
      });
    });
  }

  /* ---------- Product variants ---------- */
  function initVariants() {
    var root = document.querySelector("[data-mt-variants]");
    if (!root) return;
    var dataEl = document.querySelector("[data-mt-variant-json]");
    if (!dataEl) return;
    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var selects = root.querySelectorAll("select[data-mt-option]");
    var idInput = document.querySelector("[data-mt-variant-id]");
    var priceEl = document.querySelector("[data-mt-variant-price]");
    var submit = document.querySelector("[data-mt-buy-submit]");
    var moneyFormat = root.getAttribute("data-money-format") || "${{amount}}";

    function money(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, amount);
    }

    function update() {
      var chosen = [];
      selects.forEach(function (s) { chosen.push(s.value); });
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) {
        var html = "";
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += "<s>" + money(match.compare_at_price) + "</s> ";
        }
        html += money(match.price);
        priceEl.innerHTML = html;
      }
      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available
          ? submit.getAttribute("data-label-available") || "Add to cart"
          : submit.getAttribute("data-label-soldout") || "Sold out";
      }
    }
    selects.forEach(function (s) { s.addEventListener("change", update); });
    update();
  }

  document.addEventListener("DOMContentLoaded", function () {
    initReveal();
    initMarquee();
    initFaq();
    initCountUp();
    initGallery();
    initVariants();
  });
})();
